import React from 'react';
import { formatCurrency } from '../utils/formatters';

export interface FuncionalidadeResumo {
  id: number;
  chave: string;
  descricao: string;
  categoria: 'SAUDE' | 'EDUCACAO';
  percentual: number;
  metaMinima: number;
  aplicado: number;
  faltante: number;
  disponivelAgora: number;
  matchesCurrentSelection: boolean;
}

export interface ReservaFuncionalidadesData {
  limiteAnual: number;
  resumos: FuncionalidadeResumo[];
  percentualLivre: number;
  metaDemais: number;
  aplicadoDemais: number;
  disponivelDemais: number;
}

interface Props {
  data: ReservaFuncionalidadesData;
  loading: boolean;
}

const formatPercent = (v: number) => `${v.toFixed(1)}%`;

const ReservaFuncionalidadesPanel: React.FC<Props> = ({ data, loading }) => (
  <div className="md:col-span-2 rounded-2xl border border-line bg-surface-muted p-4">
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <h3 className="text-sm font-semibold text-fg">Reserva por funcionalidade</h3>
        <p className="mt-1 text-xs text-fg-muted">
          Cada regra guarda um minimo da dotacao anual. O que sobra pode ser usado em demais funcoes.
        </p>
      </div>
      <div className="rounded-full border border-line bg-surface px-3 py-1 text-xs font-medium text-fg-muted">
        Limite anual: {formatCurrency(data.limiteAnual)}
      </div>
    </div>

    {loading ? (
      <p className="mt-4 text-sm text-fg-muted">Carregando disponibilidade por funcao...</p>
    ) : (
      <div className="mt-4 grid grid-cols-1 gap-3 xl:grid-cols-3">
        {data.resumos.map((item) => (
          <div
            key={item.id}
            className={`rounded-2xl border p-4 ${
              item.matchesCurrentSelection
                ? 'border-info-line bg-info-soft'
                : item.categoria === 'SAUDE'
                  ? 'border-success-line bg-success-soft'
                  : 'border-info-line bg-info-soft'
            }`}
          >
            <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-fg-muted">
              {item.descricao}
            </div>
            <div className="mt-3 text-3xl font-semibold text-fg">{formatPercent(item.percentual)}</div>
            <div className="mt-3 space-y-1 text-sm text-fg">
              <div>Meta minima: {formatCurrency(item.metaMinima)}</div>
              <div>Aplicado: {formatCurrency(item.aplicado)}</div>
              <div>Disponivel agora: {formatCurrency(item.disponivelAgora)}</div>
            </div>
          </div>
        ))}

        <div
          className={`rounded-2xl border p-4 ${
            data.resumos.some((item) => item.matchesCurrentSelection)
              ? 'border-line bg-surface'
              : 'border-warning-line bg-warning-soft'
          }`}
        >
          <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-fg-muted">
            Demais funcoes
          </div>
          <div className="mt-3 text-3xl font-semibold text-fg">
            {formatPercent(data.percentualLivre)}
          </div>
          <div className="mt-3 space-y-1 text-sm text-fg">
            <div>Meta livre: {formatCurrency(data.metaDemais)}</div>
            <div>Aplicado: {formatCurrency(data.aplicadoDemais)}</div>
            <div>Disponivel agora: {formatCurrency(data.disponivelDemais)}</div>
          </div>
        </div>
      </div>
    )}
  </div>
);

export default ReservaFuncionalidadesPanel;
